type DateConstructorValue = string | number | Date;

const checkIfTimePassed = (
  date: DateConstructorValue,
  amountOfTime: DateConstructorValue
) => Date.now() - new Date(date).getTime() > new Date(amountOfTime).getTime();

export default checkIfTimePassed;
